










import { defineComponent } from '@vue/composition-api';

const Loading = defineComponent({
  // setup() {},
});

export default Loading;
